import { initializeApp } from 'firebase/app';
import { 
  getAuth, 
  setPersistence, 
  browserLocalPersistence 
} from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyAA3aEXnWoNYb21AEziQgYLkplh--ztaIQ",
  authDomain: "projeto-fidelizapp.firebaseapp.com",
  projectId: "projeto-fidelizapp",
  storageBucket: "projeto-fidelizapp.firebasestorage.app",
  messagingSenderId: "743898277721",
  appId: "1:743898277721:web:90c4725979d56aa370ce48",
  measurementId: "G-17RVJ34W2T"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);

// Set persistence to LOCAL
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log('Auth persistence set to LOCAL');
  })
  .catch((error) => {
    console.error('Error setting auth persistence:', error);
  });